import { UpperCasePipe } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-session-expiration-dialog',
  templateUrl: './session-expiration-dialog.component.html',
  imports: [TranslateModule, UpperCasePipe],
})
export class SessionExpirationDialogComponent {
  @ViewChild('modalRef') modalRef: ElementRef;
  @Input() title = 'Session expired';
  @Input() message: string;
  @Input() confirmLabel = 'Ok';

  constructor(readonly activeModal: NgbActiveModal) {}

  confirm(): void {
    this.activeModal.close(true);
  }
}
